import { Button, Collapse, Input, Typography } from "antd";
import React from "react";

import Parse from "parse";
import { SetupService } from "../state/SetupService";
import { Tenant } from "../types-generated";
import PermissionSetupList from "./PermissionSetupList";

type SetupPageProps = React.PropsWithChildren & {};
const SetupPage = (props: SetupPageProps) => {
  const service = SetupService.getInstance();
  const [masterkeyInput, setMasterkeyInput] = React.useState<
    string | undefined
  >(undefined);
  const [masterkey, setMasterkey] = React.useState<string>("");
  const [tenants, setTenants] = React.useState<Tenant[]>([]);

  React.useEffect(() => {
    if (masterkey && masterkey !== "") {
      const tenantQuery = new Parse.Query<Tenant>("OD3_Tenant");
      tenantQuery.find({ useMasterKey: true }).then((results) => {
        setTenants(results);
      });
    }
  }, [masterkey]);
  const pList = React.useMemo(() => {
    return (
      <PermissionSetupList
        permissions={service.getDefaultPermissions()}
        tenants={tenants}
      />
    );
  }, [masterkey, tenants]);
  const elements = [
    {
      key: "Permissions",
      label: "Default Permissions",
      children: <>{pList}</>,
    },

    ...Object.keys(service.getSetupComponents()).map((key) => {
      const Component = service.getSetupComponent(key);
      if (!Component) return null;
      return {
        key,
        label: key,
        children: <Component tenants={tenants} />,
      };
    }),
  ];

  return (
    <div
      style={{
        padding: "16px",
        background: "#fff",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
      }}
    >
      <h1>open.DASH Config Page</h1>
      <Input
        type="password"
        placeholder="Enter Master Key to run setup tasks ...."
        value={masterkeyInput}
        onChange={(e) => setMasterkeyInput(e.target.value)}
      />
      <Button
        onClick={() => {
          Parse.masterKey = masterkeyInput || "";
          setMasterkey(masterkeyInput);
        }}
        disabled={!masterkeyInput || masterkeyInput.length < 1}
      >
        Init masterkey
      </Button>
      {masterkey && (
        <>
          <Typography.Text type="secondary">{`${tenants.length} tenants`}</Typography.Text>

          <Collapse items={elements}></Collapse>
        </>
      )}
    </div>
  );
};

export default SetupPage;
export type { SetupPageProps };
